import { Users, Phone, MapPin } from "lucide-react";

export const RdvCard = ({ rdv }) => {
  const colors = rdv.type === "R1" ? "border-blue-500 bg-blue-500/10" : "border-purple-500 bg-purple-500/10";
  const badge = rdv.type === "R1" ? "bg-blue-500" : "bg-purple-500";
  
  return (
    <div className={`border-l-4 ${colors} rounded-lg p-3 mb-2`}>
      <div className="flex justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className={`text-xs font-bold px-2 py-0.5 rounded ${badge} text-white`}>{rdv.type}</span>
            <span className="text-white font-medium">{rdv.client}</span>
            {rdv.confirme && <span className="text-green-400 text-xs">✓</span>}
          </div>
          <div className="flex gap-3 mt-1 text-sm text-slate-400">
            {rdv.intervenant && <span className="flex items-center gap-1"><Users className="w-3 h-3" />{rdv.intervenant}</span>}
            {rdv.departement && <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{rdv.departement}</span>}
            {rdv.telephone && <a href={`tel:${rdv.telephone}`} className="flex items-center gap-1 text-blue-400"><Phone className="w-3 h-3" />{rdv.telephone}</a>}
          </div>
        </div>
        <div className="text-xs text-slate-500">{rdv.source}</div>
      </div>
    </div>
  );
};

export const DayCell = ({ date, rdvs, isToday, isCurrentMonth, onClick, isSelected }) => {
  const r1 = rdvs.filter(r => r.type === "R1").length;
  const r2 = rdvs.filter(r => r.type === "R2").length;
  
  let cellClass = "min-h-[70px] p-1 border border-slate-700 cursor-pointer ";
  cellClass += isCurrentMonth ? "bg-slate-800/50 " : "bg-slate-900/50 opacity-50 ";
  cellClass += isToday ? "ring-2 ring-amber-500 " : "";
  cellClass += isSelected ? "ring-2 ring-blue-500 bg-slate-700/50 " : "";
  
  return (
    <div onClick={() => onClick(date)} className={cellClass}>
      <div className={`text-sm font-medium ${isToday ? "text-amber-400" : "text-slate-300"}`}>{date.getDate()}</div>
      {(r1 > 0 || r2 > 0) && (
        <div className="mt-1 space-y-0.5">
          {r1 > 0 && <div className="text-xs bg-blue-500/20 text-blue-400 rounded px-1">{r1} R1</div>}
          {r2 > 0 && <div className="text-xs bg-purple-500/20 text-purple-400 rounded px-1">{r2} R2</div>}
        </div>
      )}
    </div>
  );
};

export const StatBox = ({ value, label, color }) => (
  <div className={`bg-${color}-500/10 border border-${color}-500/30 rounded-xl p-4`}>
    <p className={`text-2xl font-bold text-${color}-400`}>{value}</p>
    <p className={`text-sm text-${color}-300`}>{label}</p>
  </div>
);
